module.exports = __webpack_public_path__ + "static/media/icon-next-white.4832f5ac.svg";